<script setup lang="ts">
import {
  PhChatCircleText as ChatCircleTextIcon,
  PhPhone as PhoneIcon,
  PhShieldCheck as ShieldCheckIcon,
} from '@phosphor-icons/vue'
import { RouterLink } from 'vue-router'

const isDev = import.meta.env.DEV
</script>

<template>
  <footer class="site-footer">
    <div class="container footer-grid">
      <div class="footer-brand">
        <strong>栖居木作</strong>
        <p>用更清楚的定制过程，帮助每个家庭装好自己的生活。</p>
      </div>
      <div class="footer-links">
        <span>客户服务</span>
        <RouterLink to="/products">选柜款</RouterLink>
        <RouterLink to="/trust">服务保障</RouterLink>
        <RouterLink to="/orders">订单进度</RouterLink>
      </div>
      <div class="footer-contact">
        <span>联系与投诉</span>
        <a href="tel:4000000000"><PhoneIcon :size="17" />400-000-0000</a>
        <a href="tel:4000000000"><ChatCircleTextIcon :size="17" />平台售后受理</a>
        <p><ShieldCheckIcon :size="17" />大额款项请勿支付给个人账户</p>
      </div>
    </div>
    <div class="container footer-legal">
      <span v-if="isDev">本页面为开发演示，企业证照、价格和服务范围以上线审核资料为准。</span>
      <span>© 2026 栖居木作</span>
    </div>
  </footer>
</template>
